import { render, staticRenderFns } from "./OrgEditTab.vue?vue&type=template&id=17991b46&"
import script from "./OrgEditTab.vue?vue&type=script&lang=js&"
export * from "./OrgEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports